import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TaxNewsComponent } from './components/tax-news/tax-news.component';
import { TaxRatesSummariesComponent } from './components/tax-rates-summaries/tax-rates-summaries.component';
import { canDeactivateGuard } from '@shared/modules/rich-editor/guards/unsave-changes-check';
import { TaxRateSummariesContainerComponent } from './components/tax-rate-summaries-container/tax-rate-summaries-container.component';
import { TaxSummaryEditorComponent } from './components/tax-summary-editor/tax-summary-editor.component';
import { TaxNewsEditorComponent } from './components/tax-news-editor/tax-news-editor.component';
import { CountryHomeComponent } from './components/country-home/country-home.component';
import { CountryInformationEditorComponent } from './components/country-information-editor/country-information-editor.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: CountryHomeComponent,
  },
  {
    path: ':countryId/general-information/:countryInfoTypeId',
    component: CountryInformationEditorComponent,
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: ':countryId/tax-rates-summaries/edit/:taxSummaryId',
    pathMatch: 'full',
    component: TaxSummaryEditorComponent,
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: ':countryId/tax-rates-summaries',
    component: TaxRatesSummariesComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '1',
      },
      {
        path: ':taxSummaryTypeId',
        component: TaxRateSummariesContainerComponent,
      },
    ],
  },
  {
    path: ':countryId/tax-news',
    component: TaxNewsComponent,
  },
  {
    path: ':countryId/tax-news/edit/:taxNewsId',
    component: TaxNewsEditorComponent,
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: ':countryId/tax-news/new',
    component: TaxNewsEditorComponent,
    canDeactivate: [canDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CountryInformationRoutingModule {}
